import {
  Directive,
  HostBinding,
  Input
} from "@angular/core";
import { ButtonRounded, ButtonSize, ButtonType } from "./buttons.type";

// USE
// <button cgButton>A button</button>
// <button cgButton="secondary">A secondary button</button>

@Directive({
  selector: "[smlButton]",
  standalone: true
})
export class ButtonDirective {
  @Input() set kind(type: ButtonType) {
    this.smlButton = type;
  }
  @Input() smlButton: ButtonType | "" = "primary"
  @Input() size: ButtonSize | "" = "lg";
  @Input() rounded: ButtonRounded | "" = "lg";
  @HostBinding('disabled') @Input() disabled = false;
  @HostBinding("class.sml-button") baseClass = true;

  @HostBinding("class.sml--skeleton") @Input() skeleton = false;

  @HostBinding("class.sml-iconButton") @Input() iconButton = false;
  @HostBinding("class.sml-linkButton") @Input() link = false;
  @HostBinding("class.sml--btn--expressive") @Input() isExpressive = false;

  @HostBinding("class.sml-button-xs") get extraSmallSize() {
    return this.size === "xs" && !this.isExpressive;
  }
  @HostBinding("class.sml-button-sm") get smallSize() {
    return this.size === "sm" && !this.isExpressive;
  }
  @HostBinding("class.sml-button-md") get mediumSize() {
    return this.size === "md" && !this.isExpressive;
  }
  @HostBinding("class.sml-button-lg") get largeSize() {
    return this.size === "lg";
  }

  @HostBinding("class.sml-button-rounded-sm") get roundedSmall() {
    return this.rounded === "sm";
  }
  @HostBinding("class.sml-button-rounded-md") get roundedMedium() {
    return this.rounded === "md";
  }
  @HostBinding("class.sml-button-rounded-lg") get roundedLarge() {
    return this.rounded === "lg";
  }
  @HostBinding("class.sml-button-rounded-xl") get roundedExtraLarge() {
    return this.rounded === "xl";
  }
  @HostBinding("class.sml-button-rounded-full") get roundedFull() {
    return this.rounded === "full";
  }

  @HostBinding('class.sml-button-block') @Input() block = false;
  @HostBinding("class.sml-button-default") get defaultButton() {
    return this.smlButton === "default" || !this.smlButton;
  }
  @HostBinding("class.sml-button-default-alt") get defaultButtonAlt() {
    return this.smlButton === "default-alt" || !this.smlButton;
  }
  @HostBinding("class.sml-button-primary") get primaryButton() {
    return this.smlButton === "primary" || !this.smlButton;
  }
  @HostBinding("class.sml-button-secondary") get secondaryButton() {
    return this.smlButton === "secondary";
  }
  @HostBinding("class.sml-button-link") get linkButton() {
    return this.smlButton === "link";
  }
}
